class SelectSW extends React.Component{
    render(){
        //les noms de classe pour le DOM
        let className = "reactSelect";
        if(this.props.className !== undefined){
            className += " " + this.props.className;
        }

        //le style pour empêcher les multiselect de se déployer sur plusieurs lignes
        let customStyles = {
            valueContainer: (provided) => ({
                ...provided,
                flexWrap: "nowrap"
            })
        }

        //conserver le style demandé sur notre SelectSW
        if(this.props.styles !== undefined){
            customStyles = {...customStyles, ...this.props.styles};
        }

        //nos props spécifiques SelectSW
        const customProps = {
            classNamePrefix: "reactSelect",
            className: className,
            styles: customStyles
        }

        //readonly
        const selectReadonlyProps = this.props.readonly ? {
            isClearable: false,
            isSearchable: false,
            menuIsOpen: false
        } : {};

        //render de notre composant
        return <Select {...this.props} {...customProps} {...selectReadonlyProps} />
    }
}